export default __webpack_public_path__ + "static/media/a024-startup-3.ed3b78fe.svg";